import React from 'react';
import { Link } from 'react-router-dom';
import styles from './PricingCard.module.css';

const PricingCard = ({ plan, isYearly, onClick, disabled }) => {
  const pricing = isYearly ? plan?.yearly : plan?.monthly;

  return (
    <div className={`${styles.card} ${plan?.isPopular ? styles['card--popular'] : ''}`}>
      {plan?.isPopular && <div className={styles.card__badge}>Most Popular</div>}
      <div className={styles.card__header}>
        <p className={styles.card__name}>{plan?.name}</p>
        <p className={styles.card__description}>{plan?.description}</p>
      </div>
      <div className={styles.card__body}>
        <div className={styles.card__pricing}>
          <p className={styles.card__price}>{pricing?.price}</p>
          <p className={styles.card__period}>{pricing?.period}</p>
        </div>
        {onClick ? (
          <button
            type="button"
            onClick={onClick}
            disabled={disabled}
            className={`${styles.card__button} ${styles[`card__button--${plan?.buttonVariant}`]}`}
            style={disabled ? { opacity: 0.6, cursor: 'not-allowed' } : {}}
          >
            {plan?.buttonText}
          </button>
        ) : null
        // ) : (
        //   <Link
        //     to="/signup"
        //     className={`${styles.card__button} ${styles[`card__button--${plan?.buttonVariant}`]}`}
        //   >
        //     {plan?.buttonText}
        //   </Link>
        // )
        }
        <div className={styles.card__divider}></div>
        <ul className={styles.card__features}>
          {plan?.features.map((feature, index) => (
            <li key={index} className={styles.card__feature}>
              <span className={styles.card__featureIcon}>
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="10" cy="10" r="10" fill="#EBEBEB" />
                  <path
                    d="M14.6666 6.66663L8.24992 13.0833L5.33325 10.1666"
                    stroke="black"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </span>
              <span className={styles.card__featureText}>{feature}</span>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default PricingCard;
